module.exports = __webpack_public_path__ + "static/media/15.98a0094c.jpg";